import { concat } from 'lodash';
import React, { FC } from 'react';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue } from 'src/lib/validation/ValidationTypes';
import PruefAssistenz from 'src/pages/private/online-antrag/antrag-components/PruefAssistenz';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import { checkIfPruefAssitenzNeedsToValidate } from 'src/pages/private/online-antrag/application-helper-function/AppHelperfunctions';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

const ProjektBeschreibungEPZ: FC<{}> = () => {
	return (
		<>
			<ApplicationHeading title='Projektbeschreibung' description={PLATZHALTER_TEXT} />
			<PruefAssistenz
				statusPath={P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Pruefung_Projektbeschreibung_Pruefstatus.path}
				hinweisPath={
					P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Pruefung_Projektbeschreibung_Hinweis_Fuer_Den_Antragsteller.path
				}
				ueberarbeitetAmPath={
					P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Pruefung_Projektbeschreibung_Ueberarbeitet_Am.path
				}
				erledigtPath={P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Pruefung_Projektbeschreibung_Erledigt.path}
				formStruc={formStrucPruefAssistenz()}
			/>
		</>
	);
};

export default ProjektBeschreibungEPZ;

const formStrucPruefAssistenz = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Pruefung_Projektbeschreibung_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};

export const getFormStrucProjektBeschreibungEPZ = (application: any) => {
	if (
		checkIfPruefAssitenzNeedsToValidate(
			application,
			P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Pruefung_Projektbeschreibung_Pruefstatus.path,
			P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Pruefung_Projektbeschreibung_Erledigt.path,
		)
	) {
		return concat(formStrucPruefAssistenz());
	}

	return [];
};
